// extracted by mini-css-extract-plugin
module.exports = {"lia-messages-count":"UserMessagesCount_lia-messages-count__ccW6Q"};